module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "part",
      "id": "pt01"
    }
  }, [_c('h1', {
    staticClass: "pn"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p16"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p17"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilampert0006#rpt01"
    }
  }, [_vm._v("* 1 *")])]), _vm._v(" "), _c('h1', {
    staticClass: "pt"
  }, [_vm._v("Young Nietzsche in the Service of Schopenhauer and Wagner")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "data-locator": "p17"
    }
  }), _vm._v("Nietzsche as a young philology professor in Basel wrote five books in the service of a thinker and of an artist he wanted to believe were greater than himself, Schopenhauer and Wagner. Advancing them, he believed, would advance German culture and Western culture as a whole, both of which he judged to be threatened by a modern spiritual and intellectual malaise. The first of these books, "), _c('i', [_vm._v("The Birth of Tragedy out of the Spirit of Music")]), _vm._v(", set out Nietzsche’s view of philosophy and art in the great events of the success and failure of Attic tragedy in the tragic age of the Greeks. In Attic tragedy, the aspiration and achievement of human thinking and making reached a peak pictured mythically in Prometheus: the deepest wisdom led to the most ambitious founding, the wise founding of a people, the people that Attic tragedy could have made out of the Athenians had it not failed fortuitously at its height. That first book was followed by four "), _c('i', [_vm._v("Untimely Meditations")]), _vm._v(", untimely because they opposed modern times on behalf of a future framed by Schopenhauer and Wagner. In "), _c('i', [_vm._v("Schopenhauer as Educator")]), _vm._v(" Nietzsche laid out what a Philosopher is, in "), _c('i', [_vm._v("Richard Wagner in Bayreuth")]), _vm._v(" what an Artist is. The four "), _c('i', [_vm._v("Untimely Meditations")]), _vm._v(" were to be the first of thirteen that would in their completeness demonstrate the necessity of overthrowing modernity and establishing the new philosophy and art. But Nietzsche brought his thirteen-book project to an abrupt end shortly after publishing the Wagner book in July 1876. That end meant in part a turn toward himself, toward the perspective he had been developing privately in workbooks and had “kept secret,” as he later said, for good reason: he judged that publishing such views would endanger the social order he advocated, not enhance it.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b41ece6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-lampert-0009.vue
// module id = 78
// module chunks = 0